// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1N0oK","colMin":"styles_colMin__LBeiP","colCheckbox":"styles_colCheckbox__3_zW2"};